import { PaginationControl } from '@common/components/PaginationControl';
import { SearchBar } from '@common/components/SearchBar';
import { Title } from '@common/components/Title';
import { usePaginationControls } from '@common/hooks';
import { Layout } from '@common/layouts';
import {
    Production,
    useProductions,
    useSelectProduction,
} from '@features/productions';
import { Box, Flex, Theme } from '@radix-ui/themes';
import { DataLoaderWrapper, HomePagePath } from '@router';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ProductionSelectionUI } from './ProductionSelectionUI';

const pageSizes = [...Array(5)].map((_, i) => (i + 1) * 6);

export const ProductionSelectionPage = () => {
    const { t } = useTranslation('productionSelection');
    const navigate = useNavigate();

    const {
        data: productions,
        isLoading,
        isError,
        pageCount,
        paginationState,
        searchState,
    } = useProductions({
        pageIndex: 0,
        pageSize: pageSizes[0],
    });

    const { selectProduction } = useSelectProduction();

    const paginationControls = usePaginationControls({
        pageCount,
        pageSizes,
        ...paginationState,
        // pageIndex: paginationState.pageIndex + 1,
    });

    const handleProductionSelect = (production: Production) => {
        selectProduction(production);
        navigate(HomePagePath);
    };

    const activeProductions =
        productions?.filter(
            (production) => production.activeStatus !== 'Archived',
        ) || [];

    /* TODO: Handle auto select when only 1 production is available :     
    const handleProductionSelect = React.useCallback(
        (production: Production) => {
            selectProduction(production);
            navigate(HomePagePath);
        },
        [navigate, selectProduction],
    );
 
    const activeProductions = React.useMemo(() => {
        return (
            productions?.filter(
                (production) => production.activeStatus !== 'Archived',
            ) || []
        );
    }, [productions]);
 
    React.useEffect(() => {
        if (activeProductions.length === 1) {
            console.log(activeProductions);
            handleProductionSelect(activeProductions[0]);
        }
    }, [activeProductions, handleProductionSelect]); */

    return (
        <Layout.Content centered>
            <Theme accentColor={'gray'}>
                <DataLoaderWrapper isError={isError} isLoading={isLoading}>
                    <Box p={'4'} width={'900px'} minHeight={'400px'}>
                        <Flex
                            gap={'4'}
                            justify={'between'}
                            align={'center'}
                            mb={'8'}
                        >
                            <Title size={'7'} mb={'0'}>
                                <Trans i18nKey={'productionSelection:title'} />
                            </Title>

                            <SearchBar
                                name='Production'
                                placeholder={t('search.placeholder')}
                                {...searchState}
                            />
                        </Flex>

                        <ProductionSelectionUI
                            productions={activeProductions}
                            onSelectProduction={handleProductionSelect}
                        />

                        <PaginationControl
                            isPaginated={pageCount > 1}
                            {...paginationControls}
                        />
                    </Box>
                </DataLoaderWrapper>
            </Theme>
        </Layout.Content>
    );
};
